import React from "react";
import {
  LoadingSpinner,
  PrimaryButton,
  SecondaryButton,
} from "../../UI/DesignStandards";
import { chooseLeagueSheetFiles } from "../../../utility/averageCatalogs";

export const LeagueSheetUploadFields = ({
  leagueName,
  onLeagueNameChange,
  onFilesChange,
  onReject,
  disabled = false,
}) => {
  const handleFileChange = (event) => {
    const { accepted, rejected } = chooseLeagueSheetFiles(event.target.files);
    onFilesChange?.(accepted);
    onReject?.(rejected.join(" "));
  };

  return (
    <div className="space-y-3">
      <label className="block">
        <span className="block text-sm font-medium text-brand-charcoal mb-1">
          Files
        </span>
        <input
          type="file"
          multiple
          accept=".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg"
          onChange={handleFileChange}
          disabled={disabled}
          className="block w-full text-sm text-brand-charcoal file:mr-4 file:py-2 file:px-3 file:rounded-lg file:border-0 file:bg-brand-gold file:font-display file:font-bold file:text-brand-charcoal"
        />
      </label>
      <label className="block">
        <span className="block text-sm font-medium text-brand-charcoal mb-1">
          League name
        </span>
        <input
          type="text"
          value={leagueName}
          onChange={(event) => onLeagueNameChange?.(event.target.value)}
          placeholder="Tuesday Night"
          disabled={disabled}
          className="w-full max-w-md px-3 py-2 border border-brand-charcoal/20 rounded-lg bg-white text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
        />
        <span className="block text-sm text-brand-muted mt-1">
          Optional. Used for every file in this upload. For another league,
          upload those files separately.
        </span>
      </label>
      <p className="text-sm text-brand-muted">
        Uses AI for extraction. AI can make mistakes.
      </p>
    </div>
  );
};

export const LeagueSheetUploadForm = ({
  files,
  leagueName,
  onFilesChange,
  onLeagueNameChange,
  onReject,
  onSubmit,
  onCancel,
  extracting = false,
  extractProgress = null,
  showCancel = false,
  submitDisabled = false,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit?.(event);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      {extracting ? (
        <div className="flex items-center gap-3" role="status" aria-live="polite">
          <LoadingSpinner size="lg" />
          <p className="text-sm text-brand-charcoal">
            {extractProgress
              ? `Extracting ${extractProgress.done} of ${extractProgress.total}. This can take a minute.`
              : "Extracting this league sheet. This can take a minute."}
          </p>
        </div>
      ) : null}
      <LeagueSheetUploadFields
        leagueName={leagueName}
        onLeagueNameChange={onLeagueNameChange}
        onFilesChange={onFilesChange}
        onReject={onReject}
        disabled={extracting}
      />
      <div className="flex flex-wrap gap-2 items-center">
        <PrimaryButton
          type="submit"
          loading={extracting}
          disabled={submitDisabled || files.length === 0}
        >
          {extractProgress
            ? `Extracting ${extractProgress.done} of ${extractProgress.total}`
            : "Upload and extract"}
        </PrimaryButton>
        {showCancel ? (
          <SecondaryButton
            type="button"
            className="!px-3 !py-2 text-sm"
            onClick={onCancel}
            disabled={extracting}
          >
            Cancel
          </SecondaryButton>
        ) : null}
      </div>
    </form>
  );
};

export default LeagueSheetUploadForm;
